import {
  FETCH_WATER_MODELS_DATA_FAILURE,
  FETCH_WATER_MODELS_DATA_REQUEST,
  FETCH_WATER_MODELS_DATA_SUCCESS,
} from "../actions/waterModelData.actions";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const waterModelData = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WATER_MODELS_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_WATER_MODELS_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_WATER_MODELS_DATA_FAILURE:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default waterModelData;
